// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"370":"pivotgrid","405":"tw","410":"init","775":"bs"}[chunkId] + "." + {"370":"c1278e84","405":"c688d561","410":"c485554e","775":"0e24e792"}[chunkId] + ".chunk.css";
};